import React from 'react'

function Groups({className,children}) {
  return (
    <div className={`flex flex-col ${className}`}>{children}</div>
  )
}

export default Groups